import { useEffect, useState } from 'react';
import { navItems, siteMeta } from '@/mocks/homeContent';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-40">
      <div
        className={`border-b transition-all duration-300 ${
          scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-transparent bg-transparent'
        }`}
      >
        <nav className="container-x flex h-16 items-center justify-between gap-4" aria-label="主导航">
          <a href="#top" className="group flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
              <i className="ri-message-2-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">
              {siteMeta.brand}
            </span>
          </a>

          <div className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden items-center gap-2 lg:flex">
            <a
              href="#reviews"
              className="rounded-full border border-primary-300 px-4 py-2 text-sm font-semibold text-primary-600 transition hover:bg-primary-50"
            >
              看测评
            </a>
            <a
              href="#about"
              className="rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              我要吐槽
            </a>
          </div>

          <button
            type="button"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true"></i>
          </button>
        </nav>

        {open ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#about"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
              >
                我要吐槽
              </a>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}